import { Pipe, PipeTransform } from '@angular/core';
import {
  AbstractControl,
  FormArray, FormControl, FormGroup, Validators
} from '@angular/forms';

@Pipe({ name: 'isFormFieldRequired' })
export class IsFormFieldRequiredPipe implements PipeTransform {
  transform(
    form: FormGroup | FormArray | null,
    formControl?: AbstractControl
  ): boolean {
    if (form) {
      return form?.hasValidator(Validators.required)
      || Object
        .values(form.controls)
        .some((control) => control.hasValidator(Validators.required)
          || control.hasValidator(Validators.requiredTrue));
    } if (formControl) {
      return this.isControlRequired(formControl);
    }
    return false;
  }

  private isControlRequired(control: AbstractControl): boolean {
    // Check for direct required validators
    if (control.hasValidator(Validators.required) ||
        control.hasValidator(Validators.requiredTrue)) {
      return true;
    }

    // For custom validators that may wrap Validators.required,
    // test with an empty control to see if it produces a required error
    if (control.validator) {
      const testControl = new FormControl(null);
      // Set the parent so validators can access sibling controls if needed
      testControl.setParent(control.parent);
      const validationResult = control.validator(testControl);
      return Boolean(validationResult?.['required']);
    }

    return false;
  }
}
